import { CompanyFormState, CompanyProfile } from "./fieldsHelper/companyFields";

export const isAdminAndVisitingAddressSame = (companyFormState: CompanyFormState): boolean =>
  (companyFormState.address.visitingAddress.dto.formatted.every((addressLine, idx) => companyFormState.address.postalAddress.dto.formatted[idx] === addressLine)) && companyFormState.name === companyFormState.admName;

export const hasStageDimensions = (stage: {
  width: number | string;
  depth: number | string;
  toFloor: number | string;
  toCeiling: number | string;
} | undefined): boolean =>
  Boolean(stage && (stage.width || stage.depth || stage.toFloor || stage.toCeiling));

/**
 * @deprecated This should not be used. We should not convert betweend CompanySmall and ArtistSmall instead we should just use ArtistSmall
 **/
export const companyToArtist = (company: server.dto.CompanySmall | server.dto.Company): server.dto.ArtistSmall | undefined => {
  if (company == null) return undefined;

  return {
    artistId: company.companyId,
    name: company.name,
  }
}

export const toCompanySmall = (company: server.dto.Company): server.dto.CompanySmall | undefined => {
  if (company == null) return undefined;

  return {
    companyId: company.companyId,
    name: company.name,
    isValidated: company.isValidated,
    address: company.address
  }
}

export const getCompanyProfiles = (company: CompanyProfile, functionGroups: server.dto.FunctionGroupsConfiguration, noLongerActiveLabel: string): string[] => {
  const profiles: string[] = [];

  if (company.isArtist === "active") {
    profiles.push(functionGroups.artist.singular);
  } else if (company.isArtist === "noLongerActive") {
    profiles.push(`${functionGroups.artist.singular} (${noLongerActiveLabel})`);
  }

  if (company.isVenue === "active") {
    profiles.push(functionGroups.venue.singular);
  }

  if (company.isPromoter === "active") {
    profiles.push(functionGroups.promoter.singular);
  }

  return profiles;
}
